import { type ColumnElementType } from '../../types';

interface GetFeaturesMaxRowsProps {
  elements: ColumnElementType[];
  rowIndexes: Record<ColumnElementType, number>;
  rowsCount: number;
}

export const getFeaturesMaxRows = ({
  elements,
  rowIndexes,
  rowsCount
}: GetFeaturesMaxRowsProps) => {
  const featurePosition = elements.indexOf('features');
  const { features: featuresIndex } = rowIndexes;

  const nextElementPosition = featurePosition + 1;
  const nextElement = elements[nextElementPosition];
  const nextElementRowIndex = rowIndexes[nextElement] ?? rowsCount - 1;

  return nextElementRowIndex - featuresIndex;
};
